import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { InstallProvider } from "@/context/InstallContext";
import { InstallBanner } from "@/components/site/InstallBanner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import OurWork from "@/pages/OurWork";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <InstallProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <InstallBanner />
          <Toaster position="top-center" />
        </div>
      </InstallProvider>
    </ReactLenis>
  );
}

export default App;
